export default __webpack_public_path__ + "static/media/kycIcon.212f8481.png";